// React
import React, { useContext, useState } from 'react';

// Styles
import styles from './Filters.module.scss';

// Material UI
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  Button
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Shared
import eventBus from '../../../shared/eventBus';
import { objectsShallowEqual } from '../../../shared/helper';

// This component
export default function Filters({accordionProps}) {
  // Listing Context
  const {
    initialFilters,
    activeFilters,
    endpoint,
    getFilters,
    saveActiveFilters,
    setPage,
    setRefreshDataGrid
  } = useContext(ListingContext);

  // Filters
  const filters = getFilters();

  // Expanded states
  const [accordionExpanded, setAccordionExpanded] = useState(accordionProps && accordionProps.defaultExpanded ? accordionProps.defaultExpanded : !objectsShallowEqual(initialFilters, activeFilters));

  // Handle apply filters
  const handleApplyFilters = (event) => {
    // save applied filters in local storage
    window.localStorage.setItem('savedFilters', JSON.stringify({
      endpoint: endpoint,
      activeFilters: activeFilters
    }));

    setPage(0); // DataGrid starts at page 0, WebService starts at page 1
    setRefreshDataGrid(true);
  };

  // Handle reset filters
  const handleResetFilters = (event) => {
    // delete applied filters from local storage
    window.localStorage.removeItem('savedFilters');

    // Dispatch global event
    eventBus.dispatch('resetFilters', {
      reset: true
    });

    saveActiveFilters(initialFilters ? initialFilters : {});
    setPage(0); // DataGrid starts at page 0, WebService starts at page 1
    setRefreshDataGrid(true);
  };

  const handleAccordionChange = (e, isExpanded) => {
    setAccordionExpanded(isExpanded);
  };

  // JSX
  return (
    <>
      {filters && (
        <Accordion expanded={accordionExpanded} square={true} elevation={0} {...accordionProps} onChange={handleAccordionChange}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="secondary" />}
            aria-controls="filters-content"
            id="filters-header">
            <Typography variant="h3">Filters</Typography>
          </AccordionSummary>

          <AccordionDetails>
            {filters &&
              filters.map((row, i) => {
                return (
                  <div key={i} className={styles.row}>
                    <Grid container spacing={3}>
                      {row &&
                        row.map((filter, j) => {
                          return (
                            <Grid
                              key={j}
                              item
                              xs={filter.size.xs}
                              md={filter.size.md}
                              lg={filter.size.lg}>
                              {filter.component}
                            </Grid>
                          );
                        })}
                    </Grid>
                  </div>
                );
              })}

            <div className={styles.row}>
              <Grid container spacing={3}>
                <Grid item xs={12} md="auto">
                  <Button
                    variant="contained"
                    disableElevation={true}
                    color="secondary"
                    size="large"
                    onClick={handleApplyFilters}
                    id="apply-filters-button">
                    Apply Filters
                  </Button>
                </Grid>

                <Grid item xs={12} md="auto">
                  <Button
                    color="secondary"
                    size="large"
                    onClick={handleResetFilters}>
                    Reset Filters
                  </Button>
                </Grid>
              </Grid>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
}
